// extracted by mini-css-extract-plugin
export default {"popup":"EditAccount_popup__D+0IA","popupContent":"EditAccount_popupContent__FdJH1","buttonGroup":"EditAccount_buttonGroup__mlXLR","spanChanges":"EditAccount_spanChanges__0caHB"};